import React from "react";

type StandardCellProps = {
  value: string | string[] | null;
  className?: string;
};

export const StandardCell = ({ value, className }: StandardCellProps): JSX.Element => (
  <>{value && <span className={className}>{value}</span>}</>
);
